import CustomProductName from "@/components/desktop/products/product_name/CustomProductName";
import ExpandableTable from "@/components/desktop/list/table/ExpandableTable";
import useFilterStore from "@/stores/useFilterStore";
import { convertValue } from "@/utils/unitConverter";
import { getUnitLabel } from "@/utils/unitFormatter";
import { formatNumber, truncateToDecimals } from "@/utils/numberFormat";

import { QUANTITY_DECIMALS } from "@/components/global.constants";
import { formatDate } from "@/utils/dateFormatter";

const PurchaseHistoryDetails = ({ items }) => {
	const { filter } = useFilterStore();
	const unitMeasurement = filter?.unit_measurement || "kg_l";

	const columns = [
		{
			key: "created_date",
			label: "Fecha Ingreso",
			render: (value) => formatDate(value),
		},
		{
			key: "product_name",
			label: "Producto",
			render: (value, row) => {
				return (
					<CustomProductName
						product={{
							code: row.product_code,
							value: row.product_code,
							label: row.product_name,
						}}
					/>
				);
			},
		},
		{
			key: "total_quantity",
			label: "Cantidad envases",
			align: "right",
			render: (value) => formatNumber(value, 0),
		},
		{
			key: "container_content",
			label: "Contenido envase",
			align: "right",
			render: (value, row) => {
				if (row.unit_measure === "u") {
					return formatNumber(value, 0);
				}
				const convertedValue = convertValue(value, row.unit_measure, unitMeasurement);
				return formatNumber(truncateToDecimals(convertedValue, QUANTITY_DECIMALS), QUANTITY_DECIMALS);
			},
		},
		{
			key: "container_content_2",
			label: "Contenido total",
			align: "right",
			render: (value, row) => {
				const totalContent = row.container_content * row.total_quantity;

				if (row.unit_measure === "u") {
					return formatNumber(totalContent, 0);
				}
				const convertedValue = convertValue(totalContent, row.unit_measure, unitMeasurement);
				return formatNumber(truncateToDecimals(convertedValue, QUANTITY_DECIMALS), QUANTITY_DECIMALS);
			},
		},
		{
			key: "unit_measure",
			label: "U.M.",
			render: (value) => getUnitLabel(value, unitMeasurement),
		},
		{
			key: "total_price_local",
			label: "Costo Neto",
			align: "right",
			render: (value) => formatNumber(value, 2),
		},
		{ key: "expiration_date", label: "Fecha vencimiento", render: (value) => formatDate(value) },
	];

	return <ExpandableTable title={`Productos`} subtitle={`Total de Productos: ${items.length}`} columns={columns} data={items} rowKey="id" fullWidth={true} />;
};

export default PurchaseHistoryDetails;
